'use strict';

let count = 0;
export function uniqueId() {
  return 'spark-carousel' + count++;
}
